export const MANUAL_BUILDER_STEPS = [
  { id: 1, label: 'Basics', description: 'Goal, dates & creative' },
  { id: 2, label: 'Screens', description: 'Pick displays' },
  { id: 3, label: 'Slots', description: 'Hours — shared or per screen' },
  { id: 4, label: 'Review', description: 'Pricing & launch' },
] as const;

/** Public assets — exact filenames preserved from design proposal. */
export const SCREEN_REFERENCE_ASSETS = {
  landscape: '/screen-references/landscape-screen.png',
  portraitWall: '/screen-references/portrait-screen.png',
} as const;

export type PreviewDeviceKind = 'landscape' | 'portrait';

export function resolvePreviewDevice(opts: {
  creativeOrientation?: string;
  screenOrientation?: string;
}): PreviewDeviceKind {
  const screen = String(opts.screenOrientation || '').toUpperCase();
  const creative = String(opts.creativeOrientation || '').toUpperCase();
  const effective =
    screen === 'PORTRAIT' || screen === 'LANDSCAPE' || screen === 'SQUARE'
      ? screen
      : creative;

  if (effective === 'PORTRAIT') return 'portrait';
  return 'landscape';
}

export function screenReferenceSrc(kind: PreviewDeviceKind) {
  if (kind === 'portrait') return SCREEN_REFERENCE_ASSETS.portraitWall;
  return SCREEN_REFERENCE_ASSETS.landscape;
}
